import { get } from 'lodash';
import { WrapperEntitySelector } from '@components/Inputs';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { Grid, TextInput, Typography } from '@ts/storybook';
import { IForm } from '@ts/ui-models';

const ItemRelationForm = (props: IForm) => {
  const { requiredFields } = props;
  const isViewMode = props.mode === 'view';

  //#region Handlers
  const onChange = attrName => callbackArg => {
    const value = get(callbackArg, 'target.value', callbackArg);
    props.onChange(attrName, value);
  };

  const onChangeEntity = (field, fieldId) => entity => {
    const lid = entity ? entity.getID() : null;
    props.onChange(field, entity);
    props.onChange(fieldId, lid);
  };
  //#endregion

  return (
    <Grid container spacing={2} mt={4} px={4}>
      <Grid size={{ xs: 12 }}>
        <TextInput
          label="Name"
          value={props.values.name}
          onChange={onChange('name')}
          isReadOnly={isViewMode}
          required={requiredFields.includes('name')}
          infoText="Blank spaces at the beggining and the end will be trimmed on save"
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <WrapperEntitySelector
          searchComponent={generateSearchEntitySelector('itemRelationType')}
          value={props.values.elementRelationType ?? props.values.elementRelationTypeLid}
          onChangeEntity={onChangeEntity('elementRelationType', 'elementRelationTypeLid')}
          label="Relation type"
          isReadOnly={isViewMode}
          required={requiredFields.includes('elementRelationTypeLid')}
        />
      </Grid>
      <Grid size={{ xs: 12 }} mt={4}>
        <Typography variant="h6" text="Constraints" />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <WrapperEntitySelector
          searchComponent={generateSearchEntitySelector('itemType')}
          value={props.values.parentConstraint ?? props.values.parentElementTypeLid}
          onChangeEntity={onChangeEntity('parentConstraint', 'parentElementTypeLid')}
          label="Constraint parent item type"
          isReadOnly={isViewMode}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <WrapperEntitySelector
          searchComponent={generateSearchEntitySelector('itemType')}
          value={props.values.childConstraint ?? props.values.childElementTypeLid}
          onChangeEntity={onChangeEntity('childConstraint', 'childElementTypeLid')}
          label="Constraint child item type"
          isReadOnly={isViewMode}
        />
      </Grid>
    </Grid>
  );
};
export default ItemRelationForm;
